<template>
    <div class="wrap">
        <listHeader
            :title="title"
            :scenario="scenario"
            :operate="showOperate"
            @optionFun="headerOptionFun"
        >
        </listHeader>

        <div class="wrap-list-content">

            <a-tabs type="card" @change="changeTab" default-active-key="employee" v-if="postData.jid > 0">
                <a-tab-pane key="info" tab="职位信息"></a-tab-pane>
                <a-tab-pane key="employee" tab="员工列表"></a-tab-pane>
            </a-tabs>

            <search-screen
                :checkData="postData"
                :set-condition="{
                    pagesize: setCondition.pagesizes,
                    field: setCondition.fields,
                }"
                :config="config"
                :scenario="scenario"
                @exportRes="exportRes(0)"
                @setOption="setOption"
                @clear="clear"
                @search="search"
            >
            </search-screen>

            <div class="hro-table hro-table-only">
                <hro-table
                    :columns="columns"
                    :dataSource="data"
                    :loading="loading"
                    :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                    :scroll="scroll"
                    :rowKey="selectedKey"
                    :operate="showOperate"
                    @actionFun="actionFun"
                >

                </hro-table>
            </div>
        </div>

        <list-bottom
            :page="postData.page"
            :pagesize="postData.pagesize"
            :total="total"
            :data="data"
            :selectedRowKeys="selectedRowKeys"
            :condition="{
                  checkall: true,
              }"
            :scenario="scenario"
            :operate="showOperate"
            @checked="onCheckAllChange"
            @page="pageTo"
            @optionFun="bottomOptionFun"
        >
        </list-bottom>

        <!--员工离职-->
        <emp-departure
            v-model="showModal"
            :empid="empid"
            @confirm="getData">
        </emp-departure>

    </div>
</template>

<script>
import $ from 'jquery';
import searchScreen from '@/components/list/searchScreen';
import listBottom from '@/components/list/listBottom';
import hroTable from '@/components/list/table';
import listHeader from '@/components/list/listHeader';
import empDeparture from '@/components/modal/empDeparture';

export default {
    components: {
        listBottom,
        hroTable,
        searchScreen,
        listHeader,
        empDeparture,
    },
    data() {
        return {
            title: '合同提醒',
            scenario: 'employeeList', // 页面标识
            selectedRowKeys: [], // 选中行的key
            selectedRowKeysItem: [], // 选中行的item
            selectedKey: 'empid', // 数据主键字段（唯一）
            loading: false,// 请求
            scroll: null, //滚动
            data: [],
            setCondition: {
                fields: [],// 显示字段
                pagesizes: {},// 每页显示数筛选条件
            },
            postData: {
                keyword: '',
                supname: '',
                mid: '',
                type: '',
                sex: '',
                departure: '',
                status: '',
                contract: '',
                retirement: '',
                eid: '',
                jid: '',
                page: 1,
                pagesize: 10,
                showfield: [], // 显示字段
            },
            total: 0,
            config: {},
            empid: '',
            showModal: false, // 弹框
            showOperate: '', // 显示操作按钮
        }
    },
    computed: {
        columns() {
            // 处理显示字段
            let columns = [];
            for (let i in this.setCondition.fields) {
                let index = this.inArray(this.setCondition.fields[i].key, this.postData.showfield);
                if (index > -1) {
                    let item = {
                        title: this.setCondition.fields[i].text,
                        dataIndex: this.setCondition.fields[i].key,
                    };

                    if (i == 0 && this.setCondition.fields[i].default == 1) {
                        item.fixed = 'left';
                        item.width = 80;
                    }

                    if (this.setCondition.fields[i].key == 'name') {
                        item.scopedSlots = {customRender: 'empname'};
                        item.width = 180;
                    }

                    if (this.setCondition.fields[i].key == 'ename') {
                        item.scopedSlots = {customRender: 'ename'};
                    }

                    if (this.setCondition.fields[i].key == 'jobname') {
                        item.scopedSlots = {customRender: 'jobname'};
                    }

                    columns.push(item);
                }
            }

            let item = {
                title: '操作',
                dataIndex: 'employee_action',
                scopedSlots: {customRender: 'employee_action'},
            };

            let len = columns.length;
            if (len >= 7) {
                item.fixed = 'right';
                item.width = 150;
            } else if (len > 0 && len < 7) {
                columns[0].fixed = '';
                columns[0].width = '';
            }
            columns.push(item);

            let x = 300 + (len - 2) * 150;
            let table_width = $('.hro-table').width();
            this.scroll = x > table_width ? {x: x} : null;

            return columns;
        }
    },
    watch: {
        '$store.state.showLayoutMenu'(val) {
            $('.list-bottom').width($('.wrap-list-content').width());
        },
    },
    created() {
        // 当浏览器大小变化时
        this.listenListWindow();

        // 初始化postData
        this.setData();

        // 显示创建工资账单按钮
        if (this.postData.from != '') {
            this.showOperate = this.postData.from;
        }

        // 请求数据
        this.getData();
    },
    methods: {
        getData() {
            // init
            this.selectedRowKeys = [];

            // 加载等待
            this.loading = true;
            this.http('/manage/employee/list-contract', this.postData, (res) => {
                this.loading = false;

                // 数据渲染
                this.setCondition.fields = res['_fields'];
                this.setCondition.pagesizes = res['_pagesizes'];
                this.data = res.list.data;
                this.total = parseInt(res.list.count);
                this.postData.pagesize = parseInt(res.list.pagesize);
                this.config = res.config;

                // 初始化底部宽度
                this.$nextTick(() => {
                    $('.list-bottom').width($('.wrap-list-content').width());
                });
            }, null, 2);
        },
        // 设置参数
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;

                if (i === 'showfield') {
                    this.postData[i] = typeof this.$route.query[i] === 'string' ? [this.$route.query[i]] : this.$route.query[i];
                } else {
                    this.postData[i] = this.$route.query[i];
                }
            }

            // 初始化显示字段
            if (this.$route.query['showfield'] === undefined) {
                this.postData['showfield'] = ['type_str', 'name', 'mobile', 'ename', 'supname', 'muname', 'birth_str', 'sex_str', 'econtract_str', 'jointime_str', 'departuretime_str', 'departure_str'];
            }
        },
        // 头部操作
        headerOptionFun(e) {
            switch (e.op) {
                case 'create':
                    if (this.postData.jid) {
                        this.$router.push('/employee/create?jid=' + this.postData.jid);
                    } else {
                        this.$router.push('/job/list?from=employee');
                    }
                    break;
                default:
                    break;
            }
        },
        // 列表操作
        actionFun(e) {
            switch (e.op) {
                case 'empEdit':
                    this.$router.push('/employee/edit?empid=' + e.empid);
                    break;
                case 'departure':// 离职
                    this.empid = e.empid
                    this.showModal = true;
                    break;
                case 'join':// 入职
                    this.confirm({title: '设为入职', content: `确认将该员工设为入职状态？`}, () => {
                        this.http('/manage/employee/join', {empid: e.empid}, (res) => {
                            this.toast({content: '操作成功'});
                            this.getData();
                        }, null, 1);
                    });
                    break;
                case 'close':// 关闭
                    this.confirm({title: '删除员工', content: `确认删除该员工？`}, () => {
                        this.http('/manage/employee/close', {empid: e.empid}, (res) => {
                            this.toast({content: '操作成功'});
                            this.getData();
                        }, null, 1);
                    });
                    break;
                case 'open':// 开启
                    this.confirm({title: '恢复员工', content: `确认恢复该员工？`}, () => {
                        this.http('/manage/employee/open', {empid: e.empid}, (res) => {
                            this.toast({content: '操作成功'});
                            this.getData();
                        }, null, 1);
                    });
                    break;
                default:
                    break;
            }
        },
        // 底部操作
        bottomOptionFun(e) {
            if (this.selectedRowKeys.length === 0) {
                return false;
            }

            switch (e.op) {
                default:
                    break;
            }
        },
        changeTab(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/job/edit?jid=' + this.postData.jid);
                    break;
                case 'employee':
                    this.$router.replace('/employee/list?jid=' + this.postData.jid);
                    break;
                default:
                    break;
            }
        },
    },
}
</script>


<style lang="less" src="../../assets/css/list/list.less"></style>